module.exports = __webpack_public_path__ + "static/media/energia-logo.013dcda8.svg";